module.exports = __webpack_public_path__ + "static/img/analise-dispositivo.6ed5238.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/analise-dispositivo.png
// module id = AmA8
// module chunks = 1